<template>
  <div class="w-100 d-flex flex-wrap flex-padding">
    <!-- <div class="d-center-start w-50 mb-3"><left-text leftText="负责人"/>{{storeInfo.contact}}</div>
    <div class="d-center-start w-50 mb-3"><left-text leftText="联系电话"/>{{storeInfo.mob}}</div> -->
    <div class="d-center-start w-50 mb-3"><left-text leftText="办公电话"/>{{storeInfo.tel||'无'}}</div>
    <div class="d-center-start w-50 mb-3"><left-text leftText="总机电话"/>{{storeInfo.hotel_tel}}</div>
    <div class="d-center-start w-50 mb-3">
        <left-text leftText="开业时间"/>
        <span v-if="storeInfo.startdate>0">{{storeInfo.startdate | formatTimestamp}}</span>
    </div>
    <div class="d-center-start w-50 mb-3">
      <left-text leftText="最近装修"/>
      <span v-if="storeInfo.fitmentdate>0">{{storeInfo.fitmentdate | formatTimestamp}}</span>
    </div>
    <div class="d-center-start w-50 mb-3">
      <left-text leftText="银行卡信息"/>
      已绑定 <span class="text-link ml-1 mr-1" @click="$emit('showItemDetail','bankcard')">{{bankcard_arr.length}}</span>张银行卡
    </div>
    <div class="d-center-start w-50 mb-3">
      <left-text leftText="司陪政策"/>{{storeInfo.escort_policy}}
    </div>
      <div class="d-center-start w-50 mb-3">
      <left-text leftText="最低成团"/>{{storeInfo.min_team_num|formatVar('minTeamNumArr')}}
    </div>
    <div class="d-center-start w-50 mb-3">
      <left-text leftText="装修风格"/>{{storeInfo.decorate | formatVar('DecorationLabel')}}
    </div>
  </div>
</template>

<script>
export default {
  name: 'SupplierInfo',
  components: {},
  props: {
    storeInfo:{
      type:Object,
      default:()=>{}
    },
    bankcard_arr:{
      type:Array,
      default:()=>[]
    }
  },
  data() {
    return {
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
  .flex-padding{
    padding: 18px;
    align-items: center;
 }
</style>
